<script setup>
import { computed } from 'vue'
import { has, groupBy, isEqual } from 'lodash-es'
import CardTableColumnValue from './CardTableColumnValue.vue'
import { getNonNilArray } from '@/components/combined-predict/models/epiSuite/components/EpiSuiteCard/utils'

const props = defineProps({
  tables: {
    type: Array,
    default: () => [],
  },
  notes: {
    type: String,
    default: null,
  },
})

const sanitizedTables = computed(() => getNonNilArray(props.tables))

const getColumnClassWithRightAlignedDefaults = (table, index) => {
  return has(table.columnClasses, index) ? table.columnClasses[index] : { 'text-right': index !== 0 }
}

const getFooterClass = (table) => ({ 'bg-light': table?.headers?.filter(Boolean)?.length || table?.rows?.length })
1

const mergeFooterRowsWithSameFirstCell = (footer) => {
  const grouped = groupBy(footer, (item) => item[0]?.mainText || item[0])

  return Object.values(grouped).flatMap((pair) => {
    if (pair?.length > 1) {
      const firstItem = pair[0]?.[0]
      const allFirstElementsAreTheSame = pair.every((row) => {
        return isEqual(row?.[0], firstItem)
      })

      if (allFirstElementsAreTheSame) return [[firstItem, pair.map((row) => row[1])]]
    }
    return pair
  })
}
</script>

<template>
  <div v-if="sanitizedTables?.length || notes">
    <div
      v-for="(table, tableIndex) in sanitizedTables"
      :key="tableIndex"
      class="mb-6"
    >
      <div
        v-if="table.title"
        class="font-weight-bold"
      >
        <CardTableColumnValue :column-value="table.title" />
      </div>

      <v-simple-table dense>
        <thead v-if="table.headers?.filter(Boolean)?.length && table.rows?.length">
          <tr>
            <th
              v-for="(header, i) in table.headers"
              :key="i"
              :class="getColumnClassWithRightAlignedDefaults(table, i)"
              v-html="header"
            />
          </tr>
        </thead>

        <tbody>
          <template v-if="table.rows?.length">
            <tr
              v-for="(row, i) in table.rows"
              :key="i"
            >
              <td
                v-for="(columnValue, j) in row"
                :key="j"
                :class="getColumnClassWithRightAlignedDefaults(table, j)"
              >
                <CardTableColumnValue
                  :column-value="columnValue"
                  :value-container-class="j !== 0 ? 'justify-content-end' : ''"
                />
              </td>
            </tr>
          </template>
        </tbody>

        <tfoot
          v-if="table.footer"
          :class="getFooterClass(table)"
        >
          <tr
            v-for="(footerItem, footerIndex) in mergeFooterRowsWithSameFirstCell(table.footer)"
            :key="footerIndex"
          >
            <td :colspan="table.headers?.length || table.rows?.[0]?.length || 2">
              <div class="d-flex flex-row justify-content-between align-center">
                <CardTableColumnValue
                  :column-value="footerItem[0]"
                  class="font-weight-bolder small"
                />
                <CardTableColumnValue
                  :column-value="footerItem[1]"
                  value-container-class="justify-content-end"
                />
              </div>
            </td>
          </tr>
        </tfoot>
      </v-simple-table>

      <!-- <div
        v-if="table.footer"
        :class="getFooterClass(table)"
      >
        <div
          v-for="(footerItem, footerIndex) in mergeFooterRowsWithSameFirstCell(table.footer)"
          :key="footerIndex"
          class="d-flex flex-row justify-content-between"
        >
          <div>
            <CardTableColumnValue :columnValue="footerItem[0]" />
          </div>
          <div>
            <CardTableColumnValue
              :columnValue="footerItem[1]"
              valueContainerClass="justify-content-end"
            />
          </div>
        </div>
      </div> -->
    </div>

    <p
      v-if="notes"
      class="text-center bg-light m-0 pa-2"
    >
      {{ notes }}
    </p>
  </div>
</template>
